import { render, staticRenderFns } from "./BsColorPicker.vue?vue&type=template&id=3c2dca8e"
import script from "./BsColorPicker.vue?vue&type=script&lang=js"
export * from "./BsColorPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports